import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-en',
  templateUrl: './terms-en.component.html',
  styleUrls: ['./terms-en.component.scss']
})
export class TermsEnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
